// Returns null if valid, or a human-readable French error message otherwise.
// A patient's species must match the species of any study it's enrolled in -
// an animal study cannot contain human patients and vice versa.
export function validateSpeciesMatch(patientSpecies: string, studySpecies: string): string | null {
  if (patientSpecies !== studySpecies) {
    return `Ce patient (${patientSpecies}) ne peut pas être rattaché à une étude ${studySpecies === "human" ? "humaine" : "animale"}.`;
  }
  return null;
}
